import request from '@/utils/request' //引入封装好的 axios 请求
//行政许可信息列表
export function adminList(data = {}) {
    return request({
        url: '/rs/n3ub4/creditxzxk',
        method: 'post',
        data: data
    })
}